import { JiraLogo } from '@atlaskit/logo';
import { CobrandingComponents } from '../../../../components/whitebox-cobranding/shared-cobranding';
import { JiraBackground } from '@atlassian/product-wireframes';

const AdminExperimentForJira: CobrandingComponents = {
  background: JiraBackground,
  logo: { component: JiraLogo },
  footerProducts: 'Jira, Confluence, Trello',
};

export default AdminExperimentForJira;
